var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.type === 'rulegoJson')?_c('RenderRuleGoJsonMessage',{attrs:{"value":_vm.value},on:{"apply":_vm.onApply}}):_c('RenderMarkdownMessage',{attrs:{"value":_vm.value.content},on:{"apply":_vm.onApply}})
}
var staticRenderFns = []

export { render, staticRenderFns }